import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import { Icon20 } from 'builder/components/Icon'
import Media from 'builder/styles/media'
import Button from '../Button'

export const Container = styled.div<{ $hide?: boolean }>`
  position: fixed;
  bottom: 32px;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 12px;
  background-color: ${Colors.Neutral90};
  box-shadow: 0px 0px 1px 0px rgba(15, 56, 113, 0.32), 0px 2px 4px -1px rgba(15, 56, 113, 0.08),
    0px 8px 20px -4px rgba(15, 56, 113, 0.12);
  padding: ${Spacing.M};
  display: flex;
  z-index: 999999;

  ${({ $hide }) => $hide && 'display: none;'}

  ${Media.Tablet`
    width: 100%;
    max-width: 672px;
  `}

  ${Media.Phone`
    flex-direction: column;
    max-width: 335px;
  `}
`

export const Content = styled.div`
  display: flex;

  ${Media.Phone`
    margin-bottom: ${Spacing['2XS']};
  `}
`

export const StarContainer = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 100%;
  background-color: ${Colors.Indigo80};
  border: 3px solid white;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  margin-left: -15px;
  margin-top: auto;

  ${Media.Tablet`
    margin-top: 25px;
  `}

  ${Media.Phone`
    width: 20px;
    height: 20px;
    margin-top: 10px;
    margin-left: -10px;
  `}
`

export const Star = styled(Icon20.Star)`
  color: white;
`

export const ReviewAvatar = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 100%;

  ${Media.Phone`
    width: 32px;
    height: 32px;
  `}
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: ${Spacing['2XS']};
`

export const Title = styled.span`
  color: white;
  ${Typography.Subhead};
  ${FontWeights.DemiBold};
`

export const Subtitle = styled.span`
  color: ${Colors.Neutral50};
  ${Typography.Caption};
`

export const CloseButton = styled(Button)`
  background-color: ${Colors.Neutral90};
  margin-left: ${Spacing.L};
  border: 1px solid ${Colors.Neutral20};

  &:hover {
    background-color: ${Colors.Neutral80};
  }

  ${Media.Tablet`
    margin-left: ${Spacing['2XS']};
    height: fit-content;
  `}

  ${Media.Phone`
    font-size: 16px;
    padding: 6px 8px;
  `}
`

export const ReadButton = styled(Button)`
  margin-left: ${Spacing['2XS']};

  ${Media.Tablet`
    height: fit-content;
  `}

  ${Media.Phone`
    font-size: 16px;
    padding: 6px 8px;
  `}
`

export const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
`
